import { Storage } from 'aws-amplify';
import * as api from '../_api';

// @ts-ignore
export const create = async ({ dispatch }, one) => {
  try {
    await api.create(one);
    dispatch('snackbar/success', 'Kampagne wurde erstellt', { root: true });
    return true;
  } catch (err) {
    dispatch('snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

// @ts-ignore
export const read = async ({ commit, dispatch }) => {
  try {
    const all = await api.read();
    commit('setAll', all);
    return true;
  } catch (err) {
    dispatch('snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

// @ts-ignore
export const readOne = async ({ commit, dispatch }, { id }) => {
  try {
    const one = await api.readOne(id);
    commit('setOne', one);
    return true;
  } catch (err) {
    dispatch('snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

// @ts-ignore
export const readStats = async ({ commit, dispatch }, { id }) => {
  try {
    const one = await api.readStats(id);
    commit('setStats', one);
    return true;
  } catch (err) {
    dispatch('snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

// @ts-ignore
export const update = async ({ dispatch }, one) => {
  try {
    await api.update(one);
    dispatch('snackbar/success', 'Änderungen wurden gespeichert', { root: true });
    return true;
  } catch (err) {
    dispatch('snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

// @ts-ignore
export const remove = async ({ dispatch }, { id }) => {
  try {
    await api.remove(id);
    return true;
  } catch (err) {
    dispatch('snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

// @ts-ignore
export const generate = async ({commit, dispatch}, id) => {
  try {
    const generated = await api.generate(id);
    if (generated && generated.html) {
      commit('setGeneratedExternal', {id, html: generated.html});
    } else {
      dispatch('snackbar/error', JSON.stringify(generated.errors));
    }
    return true;
  } catch (err) {
    dispatch('snackbar/warning', err.response.data.message ? err.response.data.message : err, {root: true});
    return false;
  }
};

// @ts-ignore
export const sendTest = async ({commit, dispatch}, {id, recipient}) => {
  try {
    await api.sendTest(id, recipient);
    return true;
  } catch (err) {
    dispatch('snackbar/warning', err.response.data.message ? err.response.data.message : err, {root: true});
    return false;
  }
};
